module.exports = __webpack_public_path__ + "static/img/2.1563d5c3.png";